import type {CurrencyCode, FinanceStack, PresetKey, SliderConfig, VolumeKey, Volumes} from './types'

export const SLIDER_POSITION_MAX = 1000

export const SLIDER_CURVE_EXPONENT = 2

export const DEFAULT_CURRENCY: CurrencyCode = 'EUR'

export const DEFAULT_MINUTES_PER_TRANSACTION = 5

export const DEFAULT_HOURLY_RATE = 35

export const MIN_HOURLY_RATE = 1

export const MIN_MINUTES_PER_TRANSACTION = 1

export const MAX_HOURLY_RATE = 500

export const MAX_MINUTES_PER_TRANSACTION = 120

export const HOURS_PER_WORK_DAY = 8

export const MONTHS_PER_YEAR = 12

export const DEFAULT_PRESET: PresetKey = 'scaleUp'

export const DEFAULT_STACK: FinanceStack = 'manual'

export const FINANCE_STACKS: FinanceStack[] = ['manual', 'legacy', 'modern']

export const PRESET_KEYS: PresetKey[] = ['startup', 'scaleUp', 'enterprise']

export const VOLUME_KEYS: VolumeKey[] = ['cards', 'invoices', 'reimbursements']

export const SLIDER_CONFIGS: Record<VolumeKey, SliderConfig> = {
  cards: {max: 2000, snap: 10},
  invoices: {max: 500, snap: 5},
  reimbursements: {max: 300, snap: 5},
}

export const STACK_FACTORS: Record<FinanceStack, number> = {
  manual: 1,
  legacy: 0.6,
  modern: 0.3,
}

export const PRESETS: Record<PresetKey, Volumes> = {
  startup: {cards: 150, invoices: 30, reimbursements: 10},
  scaleUp: {cards: 400, invoices: 80, reimbursements: 30},
  enterprise: {cards: 1200, invoices: 250, reimbursements: 120},
}
